var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-title',[_vm._v(" "+_vm._s(_vm.title)+" #"+_vm._s(_vm.getRecurringTaskId)+" ")]),_c('card',[_c('create-or-update-recurring-task-form',{attrs:{"recurring-task-id":_vm.getRecurringTaskId,"mode":"update"},on:{"updateTitle":_vm.onUpdateTitle}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }